$( window ).load(function() {
  //eraseCookie('dspromotionpop');
  //eraseCookie('dspropop_close');
  // Run code
  var dspop = getCookie("dspromotionpop");
  console.log(ishomepg);
  if (dspop != "") {
    //console.log("chk->"+dspop);
    $('#globo-formbuilder-46221').hide();
  }else{
    var dsnopop = getCookie("dspropop_close");
    //console.log("nmss->"+dsnopop);
    if(ishomepg=='yes' && dsnopop==''){
  	  
       //console.log("rr");
       window.setTimeout(function () {
       var sdsnopop = getCookie("dspropop_close");
         if(sdsnopop=='') { 
          $('.floating-button').trigger("click");
           console.log("value->"+sdsnopop);
          createCookie('dspropop_close','yes',0);  
         }
         
         window.setTimeout(function () {
            // Check the filled on any field
            var pro_name=$('#name').val();
            	pro_name=$.trim(pro_name);
                
            var pro_email=$('#email').val();
                pro_email=$.trim(pro_email);
            var pro_birthdate=$('#datetime').val();
                pro_birthdate=$.trim(pro_birthdate);
           if(pro_name==''&& pro_email=='' && pro_birthdate==''){
             //createCookie('dspropop_close','yes',30); 
           	 //$('.overlay').trigger("click");
           } 
           
         },6000);  
         
       }, 2000);
      
       
    }  
    
  }
    
});

function createCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else var expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function eraseCookie(name) {
	createCookie(name,"",-1);
}

